<script setup lang = "ts">
import {ref} from "vue";

const slide = ref('image-0')
defineProps({
	images: {type: Array<string | File | FormData>, required: true},
	hasNavigation: {type: Boolean, default: true},
	classCarousel: {type: String, default: ''},
	isVertical: {type: Boolean, required: true},
	breakpoint: {type: Number, required: true},
});

const getImage = (image: any) => {
	if (image.includes('http')) {
		return image
	} else {
		return `https://cdn.compralovendelo.com/${image}`
	}
}

</script>

<template>
	<q-carousel
			v-model = "slide"
			swipeable
			animated
			control-color = "white"
			:navigation = "!!hasNavigation"
			arrows
			padding
			:class = "isVertical || $q.screen.width<=breakpoint?'w-full max-w-[370px] min-w-[320px] h-full':'h-full w-[220px] overflow-hidden'"
			ref = "parent"
	>
		<q-carousel-slide
				class = "carousel-center"
				v-for = "(image,index) in images.filter((item):item is string => typeof item === 'string')"
				:name = "`image-${index}`" v-bind:key = "index" :img-src = "getImage(image)"/>
	</q-carousel>
</template>

<style>
.carousel-center.q-carousel__slide {
	background-position: center !important;
}
</style>